import React, { useState, useEffect } from "react";
import "./App.css";
import Navigation from "./components/Navigation";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import HowItWorksSection from "./components/HowItWorksSection";
import OfferingsSection from "./components/OfferingsSection";
import BenefitsSection from "./components/BenefitsSection";
import ResearchSection from "./components/ResearchSection";
import NewsSection from "./components/NewsSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
import { Toaster } from "./components/ui/sonner";
// import LoadingSequence from "./components/ui/LoadingSequence";
import { AnimatePresence } from "framer-motion";

import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';

function App() {
  // const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const savedUser = localStorage.getItem("user");
    const token = localStorage.getItem("token");
    if (savedUser && token) {
      setUser(JSON.parse(savedUser));
    }
  }, []);

  const handleLoginSuccess = (userData) => {
    setUser(userData);
    navigate('/admin');
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setUser(null);
    navigate('/');
  };

  // Protected Admin Section Component
  const ProtectedAdmin = () => {
    if (!user) return <Navigate to="/admin/login" replace />;
    return <Dashboard user={user} onLogout={handleLogout} />;
  };

  return (
    <>
      {/* <AnimatePresence>
        {loading && <LoadingSequence onComplete={() => setLoading(false)} />}
      </AnimatePresence> */}

      <Routes>
        {/* Landing Page Route */}
        <Route path="/" element={
          // !loading && 
          (
            <div className="App animate-in fade-in duration-1000">
              <Navigation />
              <HeroSection />
              <AboutSection />
              <HowItWorksSection />
              <OfferingsSection />
              <BenefitsSection />
              <ResearchSection />
              <NewsSection />
              <ContactSection />
              <Footer />
              <Toaster />
            </div>
          )
        } />

        {/* Login Route */}
        <Route path="/admin/login" element={
          user ? <Navigate to="/admin" replace /> : (
            <>
              <Login onLoginSuccess={handleLoginSuccess} onBack={() => navigate('/')} />
              <Toaster />
            </>
          )
        } />

        {/* Admin Dashboard Route */}
        <Route path="/admin" element={
          <ProtectedAdmin />
        } />

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}



export default App;

